export const CustomValidationMessages = {
  NAME_ERROR: 'Please include your name',
  EMAIL_ERROR: 'Please match requested format: john@gmail.com',
  PASSWORD_ERROR: 'Must be at least 8 characters',
  CODE_ERROR: 'Please enter the code you received via email',
}
